<template>
    <b-container tabindex="0" class="no-border-shadow">
      <b-row class="row-even" v-for="(colorSets, index) in colors" :key="index">
        <b-col cols="2" class="p-0" v-for="(color, innerIndex) in colorSets" :key="innerIndex">
          <div class="color" :style="{backgroundColor: color}" @click="emitColor(color)">
          </div>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
import defaultColors from '../../_colors.js'

export default {
  data () {
    return {
      colors: defaultColors.colors
    }
  },
  methods: {
    emitColor (color) {
      this.$emit('colorSelected', color)
    }
  }
}
</script>

<style scoped>
.color {
  margin: .5rem .3rem;
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
}

.no-border-shadow:focus {
  outline: none;
}

.row-even {
  justify-content: space-evenly;
}
</style>




// WEBPACK FOOTER //
// src/components/utils/ColorPicker.vue